<template>
    <modal name="project-create-new-modal" :pivotY="0.2" width="590" height="auto">
        <div class="modal-img-container">
            <img class="modal-img" :src="urlForStatic('/img/projectPreviewsDemo/house3.jpg')"/>
        </div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="hideModal('project-create-new-modal')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="modal-title">
            Создать новый проект
        </div>
        <div class="modal-text">
            Назовите свой проект и добавьте одну или несколько фотографий
        </div>
        <input class="modal-text-input" type="text" placeholder="Новый проект*">
        <div class="modal-button">
            Добавить фото
        </div>
    </modal>
</template>

<script>
    import {modalMethods, urlForStaticVue} from "../common";
    import SVGModalClose from "../SVG/SVGModalClose.vue";

    export default {
        name: "ModalCreateProject",
        components: {SVGModalClose},
        mixins: [urlForStaticVue, modalMethods],
        data() {
            return {
                modal_name: "project-create-new-modal"
            }
        }
    }
</script>

<style scoped>

</style>
